import { Component, h, tag } from "omi";
import classNames from "classnames";

import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {};

@tag("nw-block")
export class NWBlock extends Component<Props> {
  static css = [tailwind];

  render() {
    return (
      <div
        class={classNames(
          "sm:flex min-w-[360px] sm:min-w-[560px] sm:max-w-[880px] p-4 my-8 sm:my-0 sm:py-16 sm:flex-col sm:items-center sm:rounded-3xl mx-auto w-full",
          { "pb-[500px]": !Store.user.isPro() },
        )}
      >
        <slot></slot>
      </div>
    );
  }
}
